import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Copyright year string. Returns "FOUNDING" if it's still the founding year,
// "FOUNDING - CURRENT" once we cross into a later year. Watizap launched in 2026.
export function copyrightYears(foundingYear = 2026) {
  const now = new Date().getFullYear();
  return now > foundingYear ? `${foundingYear} - ${now}` : `${foundingYear}`;
}
